import { isCurrency, isInt } from 'validator'

export default [{
  name: 'name',
  validation: [
    name => !name && 'A name is required.',
    name => name && name.length > 100 && 'The name must be less than 100 characters.',
  ],
}, {
  name: 'quantity',
  validation: [
    quantity => !quantity && 'A quantity is required.',
    quantity => quantity && !isInt(quantity, { min: 1 }) && 'The quantity must be an integer greater than 0.',
  ],
}, {
  name: 'isGroupTicket',
  validation: [],
}, {
  name: 'ticketIncrement',
  validation: [
    (ticketIncrement, values) => values.isGroupTicket && !ticketIncrement && 'A number is required.',
    (ticketIncrement, values) => values.isGroupTicket && ticketIncrement &&
      !isInt(ticketIncrement, { min: 1 }) && 'You must enter a value greater than 0.',
  ],
}, {
  name: 'salePrice',
  validation: [
    salePrice => !salePrice && 'A sale price is required.',
    salePrice => salePrice && !isCurrency(salePrice) && 'A valid sale price is required.',
  ],
}, {
  name: 'faceValue',
  validation: [
    faceValue => !faceValue && 'A face value is required.',
    faceValue => faceValue && !isCurrency(faceValue) && 'A valid face value is required.',
  ],
}, {
  name: 'description',
  validation: [
    description => !description && 'A description is required.',
  ],
}]



/** WEBPACK FOOTER **
 ** ./src/components/grid-ticket-modal/grid-ticket-modal-form/fields.js
 **/